import { hashKey } from "@tanstack/react-query";
import { z } from "zod";

import { factKey, personKey } from "./people-keys.ts";
import { viewerKey } from "./viewer.ts";

import type { QueryClient } from "@tanstack/react-query";

const scopeSchema = z.object({ householdId: z.string(), role: z.string() }).nullable();

const scopeOf = (data: unknown): string | undefined => {
  const scope = scopeSchema.safeParse(data);
  return scope.success ? JSON.stringify(scope.data) : undefined;
};

const viewerHash = hashKey(viewerKey);

// WHY: what a viewer may read about people follows their role, so a role or household change must not keep showing the old answers.
export const dropPeopleOnScopeChange = (queryClient: QueryClient): void => {
  let scope: string | undefined;
  queryClient.getQueryCache().subscribe((event) => {
    if (event.type !== "updated" || event.action.type !== "success" || event.query.queryHash !== viewerHash) {
      return;
    }
    const next = scopeOf(queryClient.getQueryState(viewerKey)?.data);
    if (scope !== undefined && next !== scope) {
      void queryClient.resetQueries({ queryKey: personKey });
      void queryClient.resetQueries({ queryKey: factKey });
    }
    scope = next;
  });
};
